<template>
  <div class="wrapper">
    <div>
      <span class="indent">{{ indent(site) }}</span>
      <span class="name">{{ site.name }}</span>
    </div>
    <div class="path">{{ site.path }}</div>
  </div>
</template>

<script>
export default {
  name: 'SiteMenuItem',
  props: {
    site: Object,
  },
  methods: {
    indent(site) {
      return '--'.repeat(site.path.length / 2 - 1) + ' '
    },
  },
}
</script>

<style scoped >
.wrapper {
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.indent {
  color: #ddd;
  padding-left: 1rem;
}

.path {
  color: rgb(177, 173, 173);
  font-size: 0.8rem;
  margin-left: 5rem;
}
</style>
